import { SyntheticEvent, useContext, useEffect, useState } from "react";
import { GlobeMethods } from "react-globe.gl";
import { FormattedMessage } from "react-intl";
import { LocaleContext } from "../i18n/LocaleContext";
import { LanguageName } from "../lib/country";
import { Locale } from "../lib/locale";

type Props = {
  guesses: string[];
  graphicData: any;
  r_country: number;
  countries: { features: any[] };
  globeRef: React.MutableRefObject<GlobeMethods>;
};

function reorderGuesses(guesses: string[], graphicData: any, r_country: number, countries: { features: any[] }) {
  return [...guesses].sort((a, b) => {

    const answerName = countries.features[r_country].ADMIN;

    if (isNaN(graphicData[a]) || isNaN(graphicData[b])) {
      return -1;
    }

    if (a === answerName) {
      return -1;
    } else if (b === answerName) {
      return 1;
    } else {
      return graphicData[a] - graphicData[b];
    }
      
    });

}

export default function List({ guesses, graphicData, r_country, countries, globeRef }: Props) {
  const [orderedGuesses, setOrderedGuesses] = useState(
    reorderGuesses(guesses, graphicData, r_country, countries)
  );
  const [miles, setMiles] = useState(false);
  const { locale } = useContext(LocaleContext);
  const langNameMap: Record<Locale, LanguageName> = {
    "pt-BR": "NAME_PT",
    "es-MX": "NAME_ES",
    "en-CA": "NAME_EN",
    "fr-FR": "NAME_FR",
    "de-DE": "NAME_DE",
    "hu-HU": "NAME_HU",
    "pl-PL": "NAME_PL",
    "it-IT": "NAME_IT",
    "sv-SE": "NAME_SV",
  };
  const langName = langNameMap[locale];

  useEffect(() => {
    setOrderedGuesses(reorderGuesses(guesses, graphicData, r_country, countries));
  }, [guesses, graphicData, r_country]);

  function formatKm(m: number, miles: boolean) {
    const METERS_PER_MILE = 1.60934;
    const BIN = 10;
    const value = miles ? m / METERS_PER_MILE : m;
    if (value < BIN) return " < " + BIN;

    const rounded = Math.round(value / BIN) * BIN;
    // const max = min + BIN;
    const format = (num: number) =>
      num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return ` ${format(rounded)}`;
  }

  function getFromName(name : string) {
    for (var i = 0; i < countries.features.length; i++) {

      const { NAME, NAME_LONG, ABBREV, ADMIN, BRK_NAME, NAME_SORT, ISO_A3 } =
      countries.features[i].properties;

      if (ADMIN?.toLowerCase() === name ||
       ISO_A3?.toLowerCase() === name ||
       NAME?.toLowerCase() === name ||
       NAME_LONG?.toLowerCase() === name ||
       BRK_NAME?.toLowerCase() === name ||
       ABBREV?.toLowerCase() === name ||
       NAME_SORT?.toLowerCase() === name ||
       ABBREV.replace(/\./g, "")?.toLowerCase() === name ||
       NAME.replace(/-/g, " ")?.toLowerCase() === name
       ) { return i; }

    }
    return -1;
  }

  function turnToCountry(e: SyntheticEvent, idx: string) {
    
    //const { lat, lng, altitude } = findCentre(clickedCountry);
    //turnGlobe({ lat, lng, altitude }, globeRef, "zoom");
    console.log(idx);
    var c_id = getFromName(idx.toLocaleLowerCase());
    var angle = { lng: (countries.features[c_id].bbox[0] + countries.features[c_id].bbox[2]) / 2, lat: (countries.features[c_id].bbox[1] + countries.features[c_id].bbox[3]) / 2};
    if (countries.features[c_id].properties.ADMIN === 'Russia') {
     angle = { lng: 97, lat: 64 };
    }
    globeRef.current.pointOfView(angle, 300);
  }

  const closest = orderedGuesses[0];
  const farthest = orderedGuesses[orderedGuesses.length - 1];

  const [isSortedByDistance, setIsSortedByDistance] = useState(true);
  const guessesToDisplay = isSortedByDistance ? orderedGuesses : guesses;

  //const qualifier = win ? "Answer" : "Closest";

  return (
    <div className="gues">
      {orderedGuesses.length > 0 && (
        /*<p className="text-base">
          {isSortedByDistance ? (
            <b>
              <FormattedMessage id="Closest" />
            </b>
          ) : (
            <b>
              <FormattedMessage id="Guessed" />
            </b>
          )}
        </p>*/
        
        <p className="text-center text-gray-300">
        
          <span className="text-base"><FormattedMessage id="SortBy" /> </span>
          
          <button
          onClick={() => setIsSortedByDistance(false)}
          className="mt-2 transp">
            <span className={"text-base pointer " + (!isSortedByDistance ? "underline" : "")}>
              <FormattedMessage id="SortByGuesses"/>
            </span>
          </button>

          <button
          onClick={() => setIsSortedByDistance(true)}
          className="mt-2 ml-2 transp">
            <span className={"text-base pointer " + (isSortedByDistance ? "underline" : "")} >
              <FormattedMessage id="SortByDistance"/>
            </span>
          </button>

      </p>
      )}
      <ul className="grid auto-cols-auto justify-between mt-6">
        {guessesToDisplay.map((guess, idx) => {
          var c_id = getFromName(guess.toLocaleLowerCase());
          const { NAME_LEN, ABBREV, NAME, FLAG } = countries.features[c_id].properties;
          
          var flag = (FLAG || "").toLocaleLowerCase();
          /*if (flag === 'kos' || flag === 'psx' || flag === 'sah' || flag === 'sds') {
            flag = (ADMIN || "").toLocaleLowerCase();
          }
          if (flag === 'sol' || flag === 'cyn') {
            flag = (NAME || "").toLocaleLowerCase();
          }*/

          let name = NAME_LEN >= 10 ? ABBREV : NAME;
          if (locale !== "en-CA") {
            name = countries.features[c_id].properties[langName];
          }

          return (
            
            <li className="my-1" key={idx}>
              <button
                onClick={(e) => turnToCountry(e, guess)}
                className="flex cursor-pointer transp"
              >
                <img
                  src={`https://flagcdn.com/w20/${flag.toLowerCase()}.png`}
                  alt={name}
                  className="mt-1 w-6"
                />
                <span className="ml-2 text-md text-left">{name}</span>
              </button>
            </li>
          );
        })}
      </ul>
      {closest && farthest && !isNaN(graphicData[closest]) && (
        <div className="mt-6">
          <div className="flex items-center space-x-1">
            <p className="text-base text-gray-300 mx-auto">
              <FormattedMessage id="Game8" />:
               {formatKm(graphicData[closest], true)} miles /
              {formatKm(graphicData[closest], false)} km
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
